import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import CarType from "../../interfaces/car";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PhotoProvider, PhotoView } from "react-photo-view";
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import { useState } from "react";

type PropsType = {
    data?: CarType,
    open: boolean,
    onClose: () => void,
}
export default function ReportDialog({ data, open, onClose }: PropsType) {
    const { t } = useTranslation();
    const [openDelete, setOpenDelete] = useState(false);
    const handleOpenDeleteDialog = () => {
        onClose();
        setOpenDelete(true);
    }
    const handleDelete = () => {
        axios({
            url: `/car/${data?.id}`,
            method: 'DELETE',
        }).then(res => {
            if (res.data.success) {
                setOpenDelete(false);
                window.location.reload();
            }
        });
    }
    const handleCloseDeleteDialog = () => {
        setOpenDelete(false);
    }
    return (
        <>
            <Dialog fullWidth open={open} onClose={onClose}>
                <DialogTitle>{t('report')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.chassis ?? ''} label={t('chassis_number')} /></Grid>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.type ?? ''} label={t('car_type')} /></Grid>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.year ?? ''} label={t('production_year')} /></Grid>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.license_plate_iran_code + ' ایران ' + data?.license_plate} label={t('license_plate_number')} /></Grid>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.owner_phone ?? ''} label={t('owner_phone')} /></Grid>
                        <Grid xs={12} md={6}><TextField fullWidth variant="filled" value={data?.owner_name ?? ''} label={t('owner_name')} /></Grid>
                        <Grid xs={12}><TextField multiline minRows={2} maxRows={3} fullWidth variant="filled" value={data?.body_description ?? ''} label={t('body_description')} /></Grid>
                        <Grid xs={12}><TextField multiline minRows={2} maxRows={3} fullWidth variant="filled" value={data?.chassis_description ?? ''} label={t('chassis_description')} /></Grid>
                        <Grid xs={12} md={6}><TextField multiline minRows={2} maxRows={3} fullWidth variant="filled" value={data?.public_description ?? ''} label={t('description_in_paper')} /></Grid>
                        <Grid xs={12} md={6}><TextField multiline minRows={2} maxRows={3} fullWidth variant="filled" value={data?.private_description ?? ''} label={t('performer_description')} /></Grid>
                        <Grid xs={12}>
                            <Typography className="text-text-secondary mb-3">{t('image_gallery')}:</Typography>
                            <PhotoProvider>
                                <div className=" flex flex-row gap-2 items-center">
                                    {data?.images.map((item, index) => (
                                        <PhotoView key={index} src={item.url}>
                                            <img className="h-20 w-20 rounded-md object-cover border border-solid border-primary-200" src={item.url} alt="" />
                                        </PhotoView>
                                    ))}
                                </div>
                            </PhotoProvider>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="outlined" onClick={handleOpenDeleteDialog} startIcon={<DeleteIcon />}>{t('delete')}</Button>
                    <Button startIcon={<EditIcon />} component={Link} to={`/car/${data?.id}/edit`} variant="outlined" state={{car: data}}>{t('edit')}</Button>
                    <Button startIcon={<PrintIcon />} component={Link} to={`/print/${data?.id}`} variant="contained">{t('print')}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openDelete} onClose={handleCloseDeleteDialog}>
                <DialogTitle>{t('delete_car')}</DialogTitle>
                <DialogContent>
                    <Typography>{t('are_you_sure_delete_this_car', { chassis: data?.chassis, date: new Date(data?.register_date ?? new Date).toLocaleDateString('fa-IR') })}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} variant="outlined" color="inherit">{t('cancel')}</Button>
                    <Button onClick={handleDelete} variant="contained" color="error">{t('delete')}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
